/**
 * Enum representing all action types supported by the survey SDK dispatcher.
 */
export enum ACTIONS {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
  SUBMIT = 'SUBMIT',
  START = 'START',
  CHANGE = 'CHANGE',
  SCROLL = 'SCROLL',
  RECORD_QUESTION_VIEW = 'RECORD_QUESTION_VIEW',
  RANK_ORDER_SET_RANK = 'RANK_ORDER_SET_RANK',
  RANK_ORDER_REORDER = 'RANK_ORDER_REORDER',
  MCQ_OTHER_TEXT_CHANGE = 'MCQ_OTHER_TEXT_CHANGE',
}
